'use client'

import { ItemOptionSelectForm_withOptions } from '@/app/ui/parts/default/sp/item/itemOptionSelectFormV2'
import { Dialog, DialogContent } from '@/components/ui/dialog'
import { itemOptionType, singleItemResponseType } from '@/lib/item/server'
import { serviceType } from '@/lib/service/server'
import { useEffect, useState } from 'react'

type PurchasePromotionModalProps = {
  data: singleItemResponseType
  service: serviceType
  liked: boolean
  itemOptions: itemOptionType[]
}

export function PurchasePromotionModal({
  data,
  service,
  itemOptions,
}: PurchasePromotionModalProps) {
  const [isOpen, setIsOpen] = useState(false)
  const [dontShowAgain, setDontShowAgain] = useState(false)

  useEffect(() => {
    // ローカルストレージで「今後表示しない」をチェック
    const hideModal = localStorage.getItem('hidePromotionModal')
    if (hideModal === 'true') return

    // 30秒後にモーダル表示
    const timer = setTimeout(() => {
      setIsOpen(true)
    }, 30000) // 30秒

    return () => clearTimeout(timer)
  }, [data.item.item_id])

  const handleClose = () => {
    localStorage.setItem('hidePromotionModal', 'true')
    setIsOpen(false)
  }

  return (
    <Dialog open={isOpen} onOpenChange={handleClose}>
      <DialogContent className="max-w-md w-[92%] max-h-[80vh] overflow-y-auto p-0 gap-0">
        <div className="relative">
          {/* モーダル内容 */}
          <div className="bg-white">
            <div className="p-4">
              <p className="text-[#333] text-center text-sm">
                この商品が気になりましたか？
              </p>
              <p className="text-[#333] text-sm text-center mt-1">
                <span className="px-2 py-1 rounded font-bold text-base">
                  会員登録なしで購入
                </span>
                できます。
              </p>
            </div>

            <div className="w-[90%] mx-auto border-t">
              <img
                src={data.item.image_url}
                alt="Promotion Banner"
                className="h-[300px] w-full object-contain bg-white"
                loading="lazy"
              />
              <p className="text-center text-base text-gray-600 my-4 font-bold">
                {data.item.name}
              </p>

              <div className="promotion-modal-add-cart-form">
                <div className="add-cart-form m-auto space-y-4 m-4">
                  <ItemOptionSelectForm_withOptions
                    service={service}
                    item={data.item}
                    itemOptions={itemOptions}
                    promotionModal={true}
                  />
                </div>
              </div>
            </div>

            {/* 今後表示しないチェックボックス */}
            <div className="promotion-modal-checkbox p-4 border-t bg-gray-50">
              <label className="flex items-center space-x-2 text-sm text-gray-600 text-center">
                <input
                  type="checkbox"
                  checked={dontShowAgain}
                  onChange={(e) => setDontShowAgain(e.target.checked)}
                  className="rounded"
                />
                <span>今後は表示しない</span>
              </label>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
